import React from "react";
import { CutAccountWidget } from "./cutAccountWidget";
import Bold from "../../../components/bold/bold";
import { formatMoney } from "../../../utils/helpers/stringHelper";
import { Frown, Smile } from "../../../components/icons";
import { useAccount } from "../../../hooks/client";
import { useTheme } from 'styled-components';

export const AccountSummary = ({ accountNumber }) => {
  const theme = useTheme();
  const activeAccountData = useAccount(accountNumber) || {};
  const isArrears = activeAccountData.arrearsValue > 0;

  const formatNetBalance = formatMoney(activeAccountData.netBalance);
  const formatArrearsValue = formatMoney(activeAccountData.arrearsValue);
  const formatNextPaymentAmount = formatMoney(
    activeAccountData.nextPaymentAmount
  );

  return (
    <div className="manage-repayments-container">
      {activeAccountData.length !== 0 && (
        <div className="manage-repayments-widget">
          <div className="information-list">
            {isArrears === false ? (
              <h2 className="info-title-group">
                <Smile width="32px" />
                <Bold className="info-title">
                  Your loan is currently tracking well
                </Bold>
              </h2>
            ) : (
              <h2 className="info-title-group-arrears">
                <Frown width="32px" themeColor={theme.palette.main.white} themeColorDesktop={theme.palette.status.bad} />
                <Bold className="info-title">
                  Your loan is currently in{" "}
                  <span className="red-text">arrears</span>
                </Bold>
              </h2>
            )}
            <p className="info-netbalance">
              Your current balance is <Bold>{formatNetBalance}</Bold>
            </p>
            <div className="line" />
            {isArrears === true ? (
              <div>
                <p className="info-arrears">
                  Your current arrears are <Bold>{formatArrearsValue}</Bold>
                </p>
                <div className="line" />
              </div>
            ) : (
              ""
            )}
            <p className="info-repayments">
              Your regular repayments are <Bold>{formatNextPaymentAmount}</Bold>
            </p>

          </div>
          <div className="hide-mobile">
            <CutAccountWidget account={activeAccountData} />
          </div>
        </div>
      )}
    </div>
  );
};
